import { SkillFormat } from "../../enum/enumSkillFormat";

/**
 * This model class contains all the data that are alway needed for interacting with a peculiar Skill of a specif
 * instance of SmartComponent object.
 *
 * NOTE: In the implementation, we use the child-classes of this class, since they contain additional properties needed
 * depending if we want to configure/customize the skill or if we are merely fetching the data from server.
 */
export class SmartComponentSkillValorization {
  public id: number = 0;
  public titleSkill: string = "";
  public shortDescriptionSkill: string = "";
  /**This flag specify the "valorization-type" the skill is expecting; if "TEXT", the skill is a simple textual property.
   * IF "ADDRESS", the skill is a feature bounded to a Address, therefore the property "Address" is valorized.
   */
  public dataFormat: SkillFormat;
  public isWritable: boolean;
  public isRequired: boolean;
  public value: string = "";
  public default: string = "";

  constructor(controlType?: any) {}
}
